<template>
  <v-dialog v-model="dialog" max-width="800px" persistent>
    <!-- <template v-slot:activator="{ on }">
      <v-btn color="primary" dark class="mb-2" v-on="on">New Item</v-btn>
    </template> -->
    <v-card v-if="dishe">
      <!-- <v-card-title>
        <span class="headline">{{ dishe.FoodNameFormatted }}</span>
      </v-card-title> -->

      <v-card-text>
        <v-container>
          <food-drink :content="dishe" />
          <availability :data="dishe" :onChange="handleUpdateAvailability" />
          <!-- <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field v-model="editedItem.name" label="Dessert name"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field v-model="editedItem.calories" label="Calories"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field v-model="editedItem.fat" label="Fat (g)"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field v-model="editedItem.carbs" label="Carbs (g)"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field v-model="editedItem.protein" label="Protein (g)"></v-text-field>
            </v-col>
          </v-row> -->
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <!-- <v-btn color="blue darken-1" text @click="onClose">{{$t('common.cancel')}}</v-btn>
        <v-btn color="blue darken-1" text @click="handleSave">{{$t('common.save')}}</v-btn> -->
        <v-btn class="mr-4" @click="onClose">{{ $t('common.cancel') }}</v-btn>
        <v-btn dark :color="enterpriseColor" @click="handleSave">{{ $t('common.save') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import Availability from '@/components/Availability'
  import FoodDrink from '../menus/formMenu/content/foodDrink/Index'
  export default {
    components: {
      Availability,
      FoodDrink
    },
    props: {
      dialog: {
        type: Boolean,
        required: true
      },
      data: {
        type: Object,
        required: false,
        default: null
      },
      onSave: {
        type: Function,
        required: true
      },
      onClose: {
        type: Function,
        required: true
      }
    },
    data: () => ({
      dishe: null
    }),
    computed: {
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      }
    },
    watch: {
      data: {
        handler: function (newValue) {
          this.dishe = newValue
        },
        deep: true
      },
    },
    mounted () {
      this.dishe = this.data
    },
    methods: {
      handleUpdateAvailability (value) {
        // this.dishe.Availability = value
        this.dishe.IsTemp = value.isTemp
        this.dishe.Per = value.per
        this.dishe.DateStart = value.dateStart
        this.dishe.DateEnd = value.dateEnd
        this.dishe.TimeStart = value.timeStart
        this.dishe.TimeEnd = value.timeEnd
        this.dishe.IsAllTimes = value.isAllTimes
        this.dishe.IsAllDays = value.isAllDays
        this.dishe.Rec = value.rec
        this.dishe.DayOfWeek = value.dayOfWeek
        this.dishe.DayOfMonth = value.dayOfMonth
        this.dishe.Alt = value.alt
      },
      handleSave () {
        this.onSave(this.dishe)
      }
    }
  }
</script>